import React from 'react';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { DialogActions, DialogTitle, Typography } from '@mui/material';
import SubscriptionStatus from 'types/SubscriptionStatus';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  open: boolean;
  onClose: () => void;
  cancel: () => void;
  status: SubscriptionStatus;
  name: string;
};

const ConfirmCancelSubscription:React.FC<Props> = ({ open, onClose, cancel, status, name }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      aria-describedby="confirm-cancel-dialog-slide-description"
    >
      <DialogTitle id="confirm-cancel-dialog-title" sx={{ fontWeight: 600 }}>
        {`Cancel \`${name}\` subscription package?`}
      </DialogTitle>
      <DialogContent sx={{ minWidth: '450px', maxWidth: '100%' }}>
        <Typography>
          {status === SubscriptionStatus.Trial
            ? 'Your subscription will be terminated at once, and you\'ll be logged out.'
            : 'Your subscription will be terminated at the end of billing period.'
          }
        </Typography>
        <Typography>
          This action cannot be undone
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pt: 4 }}>
        <Button variant="text" onClick={onClose}>No</Button>
        <Button variant="contained" onClick={cancel}>Yes</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmCancelSubscription;
